import { Component, OnInit } from '@angular/core';
import {Constant} from '../../../../../shared/constants/constant.class';
import {WarehouseService} from '../../../../../service/warehouse.service';
import { Router } from '@angular/router';
import { AppConfigService } from 'src/app-config.service';

@Component({
  selector: "app-warehouse-select",
  templateUrl: "./warehouse-select.component.html",
  styleUrls: ["./warehouse-select.component.scss"],
})
export class WarehouseSelectComponent implements OnInit {
  warehouses = [];
  selectedWarehouseId: any;
  isLab = false;
  isMaster = false;
  selectedWarehouse: any;
  userInWarehouses: any[] = [];
  userInfo: any;
  warehouseRoles = [];
  isAbleToConfirmed: boolean;
  baseUrl: any;
  constructor(
    private warehouseService: WarehouseService,
    private router: Router,
    private configService: AppConfigService
  ) {}

  ngOnInit(): void {
    this.userInfo = JSON.parse(localStorage.getItem(Constant.USER_INFO));
    this.selectedWarehouseId = +localStorage.getItem(Constant.WAREHOUSE_ID);
    this.isMaster =
      +localStorage.getItem(Constant.WAREHOUSE_ID) === 1 ? true : false;
    this.getUserWarehouses();
    this.getSelectedWarehouse();
    const initData = JSON.parse(localStorage.getItem(Constant.INIT_DATA));
    this.warehouseRoles = initData.wareHouseRoles;
    this.baseUrl = this.configService.getConfig().api.baseUrl;
  }
  getUserWarehouses() {
    console.log(this.userInfo);
    this.warehouseService.getWarehousesByUserId(this.userInfo.id).subscribe(
      (res) => {
        this.warehouses = res;
        if (res.length === 0) {
          this.changeWarehouse(res[0]);
        }
      },
      (error) => {}
    );
  }

  changeWarehouse($event: any) {
    // tslint:disable-next-line:variable-name
    const selected_warehouse = this.warehouses.find((en) => en.id === +$event);
    localStorage.setItem(Constant.WAREHOUSE_ID, selected_warehouse.id);
    // @ts-ignore
    localStorage.setItem(
      Constant.WAREHOUSE_MASTER,
      selected_warehouse.parentId
    );
    // location.href = location.href;
    location.href = location.origin + "/admin/warehouse-hub/inventory";
  }
  getSelectedWarehouse() {
    this.selectedWarehouseId = +localStorage.getItem(Constant.WAREHOUSE_ID);
    this.warehouseService.getWarehouseById(this.selectedWarehouseId).subscribe(
      (res) => {
        this.userInWarehouses = res.tblUserWareHouses;
        console.log(this.userInWarehouses);
        this.checkRoleUser();
        this.selectedWarehouse = res;
        this.isLab = res.isLab;
      },
      (error) => {}
    );
  }
  checkRoleUser() {
    this.isAbleToConfirmed =
      this.userInWarehouses.filter(
        (en) => en.userId == this.userInfo.id && en.wareHouseRoleId == 2
      ).length > 0
        ? true
        : false;
    /*
      [
        {
          "id": 1,
          "name": "Quản lý kho"
        },
        {
          "id": 2,
          "name": "Xác nhận đã nhận"
        }
      ]
    */
  }
}
